import api from './api'

const teamService = {
  async list() {
    const response = await api.get('/teams')
    return response.data
  },
  async create(data) {
    const response = await api.post('/teams', data)
    return response.data
  },
  async update(id, data) {
    const response = await api.put(`/teams/${id}`, data)
    return response.data
  },
  async remove(id) {
    const response = await api.delete(`/teams/${id}`)
    return response.data
  },
  // Danh sách người có thể nhận phân công (theo phạm vi của user hiện tại)
  async assignableUsers() {
    const response = await api.get('/teams/assignable-users')
    return response.data
  },
}

export default teamService
